import React from "react";
import Tenant from "../../../component/tenant/tenant";
import Promo from "./section/promo/promo";
import Inforesidential from "../residential/section/info-residential/inforesidential";
import Ruko from "./section/ruko/ruko.jsx";
import Buttoncta from "../../../component/buttoncta-commersial/buttoncta-commercial.jsx";
import ScrollToHashElement from "../residential/ScrollToHashElement.js";

const commercial = () => {
  return (
    <div className="commercial">
      <ScrollToHashElement />
      <Promo />
      <Inforesidential />
      <Tenant />
      <Ruko />
      <Buttoncta />
    </div>
  );
};

export default commercial;
